/**
 * useAuth Hook
 *
 * Reads auth state from AuthContext.
 * Must be used inside <AuthProvider> (mounted once in App.tsx).
 */

import { useContext } from 'react';
import { AuthContext, type AuthState } from '@/context/AuthContext';

export type UseAuthReturn = AuthState;

export function useAuth(): UseAuthReturn {
  const ctx = useContext(AuthContext);
  if (!ctx) {
    throw new Error('useAuth must be used within an <AuthProvider>');
  }
  return ctx;
}
